module.exports = __webpack_public_path__ + "static/media/2019091622.ee40bb88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/2019091622.jpg
// module id = 207
// module chunks = 0